import {
  CompleteOrganizationAsCompanyBodySchema,
  CompleteOrganizationAsCompanyResponseSchema,
  type CompleteOrganizationAsCompanyBody,
} from '@zrsystem/contracts';

import { platformHttp } from '@/features/platform/api/platform-http.js';
import { getHttpClient } from '@/shared/api/http-client.js';

export async function completeOrganizationAsCompany(
  organizationId: string,
  body: CompleteOrganizationAsCompanyBody,
) {
  const parsed = CompleteOrganizationAsCompanyBodySchema.parse(body);
  const raw = await platformHttp.post<unknown>(
    `/organizations/${organizationId}/complete-as-company`,
    parsed,
  );
  return CompleteOrganizationAsCompanyResponseSchema.parse(raw);
}

export async function completeCurrentOrganizationAsCompany(
  body: CompleteOrganizationAsCompanyBody,
) {
  const parsed = CompleteOrganizationAsCompanyBodySchema.parse(body);
  const raw = await getHttpClient().post<unknown>('/api/organization/complete-as-company', parsed);
  return CompleteOrganizationAsCompanyResponseSchema.parse(raw);
}
